import { Component } from '@angular/core';
import { SharedService } from '../../../../Services/shared.service';
import { distinctUntilChanged } from 'rxjs';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Dialog } from '@angular/cdk/dialog';
import { DialogExamSubmitComponent } from '../../../MockTest/Components/exam/dialog-exam-submit/dialog-exam-submit.component';
@Component({
  selector: 'app-report',
  imports: [RouterModule, CommonModule, FormsModule],
  templateUrl: './report.component.html',
  styleUrl: './report.component.css'
})
export class ReportComponent {
  PREP_UserInfo: any;
  ReportList: any[] = [];
  ReportList_Pres: any[] = [];
  SubjectList: any[] = [];
  Subject: any = "";
  IsShowMessage: boolean = false
  constructor(public _svc: SharedService, public _dialog: Dialog) {

  }
  ngOnInit(): void {
    this._svc.get_Login_Status().pipe(distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)))
      .subscribe(x => {
        this.PREP_UserInfo = x;
        if (this.PREP_UserInfo != null) {

          this.Get_Analitical_Progress();
        }
      });
  }

  Get_Analitical_Progress(): void {
    this.IsShowMessage = false;
    this.SubjectList = [];
    this.ReportList = [];
    this._svc.GET(API_End_Point.Get_Analitical_Progress)
      .subscribe((res) => {
        if (res.result === 'success') {
          this.ReportList_Pres = (res.data || []).filter((x: any) => x.classId == this.PREP_UserInfo.classId);
          if (this.ReportList_Pres.length > 0) {
            this.SubjectList = this._svc.uniqueBy(this.ReportList_Pres, "subjectName");
            //this.Subject = this.SubjectList[0].subjectName;
            this.Subject = "All";
            this.Subject_Changed();
          }
          else
            this.IsShowMessage = true
        } else {
          this.ReportList = [];
        }
      });
  }

  Subject_Changed() {
    this.ReportList = this.ReportList_Pres.filter(x => x.subjectName == (this.Subject == "All" ? x.subjectName : this.Subject));
  }

  Get_Question_For_ReSubmit(_obj: any): boolean {

    if (_obj.examStatus == 'Test not submitted') {
      if (localStorage.getItem('PREP' + _obj.id) != null)
        return true;
      else
        return false

    } else return false
  }

  ReSubmit(_examObject: any) {
    var _obj = {
      questionList: JSON.parse(localStorage.getItem('PREP' + _examObject.id) || '[]'),
      Enable_Yes_For_Submit: false,
    }
    _obj.Enable_Yes_For_Submit = true;

    this._dialog.open(DialogExamSubmitComponent, {
      data: _obj
    }).closed.subscribe((res: any) => {

      if (res.result == "ExamSubmit") {
        this.ExamSubmit(_examObject)
      }
    });
  }

  ExamSubmit(_examObject: any) {
    try {
      const body = {
        ExamCode: 'PREP' + _examObject.id,
        IsManual: true,
        QuestionList: JSON.parse(localStorage.getItem('PREP' + _examObject.id) || '[]').map((q: any) => ({
          QNO: q.QNo,
          QuestionId: q.QuestionId,
          AnsId: q.AnsId,
          IsDought: null,
          TimeTaken: q.TimeTaken
        }))
      };
      this._svc.POST(body, '/ManageMock/SubmitExam').subscribe(response => {
        if (response.result.toLowerCase() == 'success') {
          localStorage.removeItem('PREP' + _examObject.id)
          this.Get_Analitical_Progress();
        }
        else
          this._svc.Notification("error", response.message);
      });
    }
    catch (e) {
    }
  }
  ResumeTest(_examObject: any) {

    localStorage.setItem('PREP_ExamDetails', JSON.stringify({ ChildId: _examObject.childId, SubjectName: _examObject.subjectName, eventLetter: _examObject.eventLetter, classId: _examObject.classId, MockSet: _examObject.mockSet }));
    window.location.href = '/exam'

  }

  Switch_Child() {
    this._svc.Switch_Child().then((res: any) => {
      this.ngOnInit();
    })
  }
}
